module.exports = __webpack_public_path__ + "static/media/4.1c0ae8c3.jpg";